import Api from './Api';

const AUTH_URL = `${process.env.REACT_APP_BASE_URL}/v2/auth`;

// Neither endpoint takes a bearer token, and both must bypass the
// authenticated post to avoid recursing into the token-refresh path.
export const login = (credentials) =>
  Api.postUnauthenticated(`${AUTH_URL}/login`, credentials);

export const refreshSession = (data) =>
  Api.postUnauthenticated(`${AUTH_URL}/refresh`, data);
